var $17e82ebf0f8ab91f$exports = {};
$17e82ebf0f8ab91f$exports = {
  "buttonLabel": "Suggesties weergeven",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " optie");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opties");
      }
    }), " beschikbaar.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Groep ".concat(args.groupTitle, " ingevoerd met ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " optie");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opties");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", geselecteerd",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Suggesties",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", geselecteerd");
  }
};
export { $17e82ebf0f8ab91f$exports as default };